import React from "react";

import _ from "lodash";

import {connectDynamic} from "go/components/dynamic/dynamicComponent";
import {AuthSubmitWrapper} from "go/components/dynamic/modules/form/submitWrappers/AuthSubmitWrapper";
import {AuthSignWrapper} from "go/components/dynamic/modules/form/submitWrappers/AuthSignWrapper";
import {ContentDispatch} from "framework";
import {isLoginGovUser} from 'common/utils';

export const AuthSubmitButton = (props) => {
  const {
    handleSubmit,
    confirmationLabel,
    errorAlertHeader,
    childSubmitButton,
    childSubmitButtonConfig,
    content,
    invalidPasswordMessage,
    username,
    entityId,
    entityType,
    onSign,
    entitiesToLockUnlock,
    grantId,
    toggles
  } = props;

  // use childSubmitButtonConfig, or if it doesn't exist, use childSubmitButton string, or if it doesn't have either prop, use 'DynamicSubmitButton'
  const buttonConfig = _.has(childSubmitButtonConfig, "type")
    ? childSubmitButtonConfig
    : {type: childSubmitButton || "DynamicSubmitButton"};

  const propsToPass = {
    ...props,
    childSubmitButton: undefined, // prevent child from rendering itself infinitely when passed childSubmitButton
    childSubmitButtonConfig: _.get(buttonConfig, "childSubmitButtonConfig"),
    config: {
      ...props.config,
      ...buttonConfig,
    },
  };

  const loginGovIntegration = isLoginGovUser();
  if (propsToPass.disableText) {
    propsToPass.disableText = loginGovIntegration ? _.replace(propsToPass.disableText, ' and enter your password', '') : propsToPass.disableText;
  }
    //AuthSignWrapper
    // onSign
    // to use AuthRedirectWrapper provide  onSign : true.
    // It will update page to read only state.  
  return (
    <React.Fragment>
      {onSign ? (
        <AuthSignWrapper
          handleSubmit={handleSubmit}
          confirmationLabel={confirmationLabel}
          errorAlertHeader={errorAlertHeader}
          invalidPasswordMessage={invalidPasswordMessage}
          username={username}
          entityId={entityId}
          entityType={entityType}
          entitiesToLockUnlock={entitiesToLockUnlock}
          grantId={grantId}
          toggles={toggles}
        >
          {(updateHandleSubmit, valid) => {
            return(
              <ContentDispatch
                {...propsToPass}
                getAuthentication={updateHandleSubmit}
                isDisabled={!valid}
              />
            )
          }}
        </AuthSignWrapper>
      ) : (
        <AuthSubmitWrapper
          permissions={_.get(props, 'context.auth.permissions')}
          handleSubmit={handleSubmit}
          confirmationLabel={confirmationLabel}
          content={content}
          errorAlertHeader={errorAlertHeader}
          invalidPasswordMessage={invalidPasswordMessage}
        >
          {(updateHandleSubmit, valid) => (
            <ContentDispatch
              {...propsToPass}
              handleSubmit={updateHandleSubmit}
              isDisabled={!valid}
            />
          )}
        </AuthSubmitWrapper>
      )}
    </React.Fragment>
  );
};

export default connectDynamic(AuthSubmitButton);
